<script>
import ListDefault from "../Utils/Page/ListDefault";

export default {
    name: "List",
    mixins: [ListDefault],
    data() {
        return {
            lang: this.$ml.get('pages.user'),

            filter: {
                name: { value: null, type: 'text'},
                first_name: { value: null, type: 'text'},
                last_name: { value: null, type: 'text'},
                email: { value: null, type: 'text'},
                subscription: { value: null, type: 'select', options: [] },
                greenhouse: { value: null, type: 'select',
                    options: [
                        { id: false, title: this.$ml.get('interface.no') },
                        { id: true, title: this.$ml.get('interface.yes') },
                    ]
                },
                is_pro: { value: null, type: 'select',
                    options: [
                        { id: false, title: this.$ml.get('interface.no') },
                        { id: true, title: this.$ml.get('interface.yes') },
                    ]
                },
            },
            tableHeader: [
                //{ label: '#', is_sort: false },
                { key: 'id', is_sort: true },
                { key: 'name', is_sort: true, classes: 'text-l' },
                { key: 'first_name', is_sort: true, classes: 'text-l' },
                { key: 'last_name', is_sort: true, classes: 'text-l' },
                { key: 'email', is_sort: true, classes: 'text-l' },
                { key: 'provider', is_sort: true, classes: 'text-l' },
                { key: 'subscription', is_sort: true, classes: 'text-l' },
                { key: 'count_artifacts', is_sort: true, classes: 'text-l' },
                { key: 'how_know', is_sort: false, classes: 'text-l wrap' },
                { key: 'greenhouse', is_sort: false, classes: 'text-l wrap' },
                { key: 'is_pro', is_sort: true, classes: 'text-l wrap' },
            ],

            tableBody: {
                subscription: {
                    type: 'function',
                    function: this.getSubscription
                },
                how_know: {
                    type: 'function',
                    function: this.getHowKnow
                },
                greenhouse: {
                    type: 'function',
                    function: this.getGreenhouse
                },
                is_pro: {
                    type: 'function',
                    function: this.getIsPro
                },
            },

            apiList: this.$store.getters.getApiUrl('user'),
            pageRoute: 'user',
            pageRouteCreate: 'user.create',
            pageRouteEdit: 'user.edit',
            pagePermission: 'user',
        }
    },
    mounted() {
        this.getDictionaries().then(({data}) => {
            this.dictionaries = data.dictionaries

            this.filter.subscription.options = this.dictionaries.subscription
        })
    },
    methods: {
        getIsPro(item) {
            if (item.is_pro) {
                return 'Yes'
            }
            return '-'
        },
        getGreenhouse(item) {
            if (item.greenhouse) {
                return 'Yes'
            }
            return '-'
        },
        getHowKnow(item) {
            if (item.how_know) {
                return JSON.parse(item.how_know).join(', ')
            }
            return '-'
        },
        getSubscription(item) {
            if (item.subscription_plan) {
                return item.subscription_plan.title
            }
            return null
        }
    }
}
</script>

<style scoped>

</style>
